import { PhoneCall } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SiteNavigationTab } from '~/pages/Home/SiteNavigation/shared/SiteNavigationTab'
import { TabImplementationProps } from '~/pages/Home/SiteNavigation/tabImplementations/TabImplementationTypes'

export const CallsTab = ({
  id,
  isSelected,
  isCollapsed,
  onClick,
}: TabImplementationProps) => {
  const { t } = useTranslation()

  return (
    <SiteNavigationTab
      id={id}
      title={t('nav.calls')}
      icon={PhoneCall}
      isSelected={isSelected}
      isCollapsed={isCollapsed}
      onClick={onClick}
    />
  )
}
